import { Navigate, Outlet, createBrowserRouter } from "react-router";
import { AuthProvider } from "./auth/AuthProvider.js";
import { ProtectedRoute } from "./auth/ProtectedRoute.js";
import { CanvasBenchmarkPage } from "./canvas/CanvasBenchmarkPage.js";
import { ProductionCanvasPage } from "./canvas/ProductionCanvasPage.js";
import { ChangePasswordPage } from "./routes/ChangePasswordPage.js";
import { GenerationAuditPage } from "./routes/GenerationAuditPage.js";
import { GenerationHistoryPage } from "./routes/GenerationHistoryPage.js";
import { LoginPage } from "./routes/LoginPage.js";
import { ProjectsPage } from "./routes/ProjectsPage.js";
import { AdminLayout } from "./admin/AdminLayout.js";
import { MembersPage } from "./admin/MembersPage.js";
import { FeedbackPage } from "./admin/FeedbackPage.js";
import { FeedbackDetail } from "./admin/FeedbackDetail.js";
import { OverviewPage } from "./admin/OverviewPage.js";
import { UsagePage } from "./admin/UsagePage.js";
import { GenerationTasksPage } from "./admin/GenerationTasksPage.js";
import { AuditPage } from "./admin/AuditPage.js";

function AuthenticatedApplication() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}

export const router = createBrowserRouter([
  {
    path: "/benchmark",
    element: <CanvasBenchmarkPage />
  },
  {
    element: <AuthenticatedApplication />,
    children: [
      {
        path: "/login",
        element: <LoginPage />
      },
      {
        element: <ProtectedRoute passwordChangeOnly />,
        children: [
          {
            path: "/change-password",
            element: <ChangePasswordPage />
          }
        ]
      },
      {
        element: <ProtectedRoute />,
        children: [
          {
            path: "/projects",
            element: <ProjectsPage />
          },
          {
            path: "/generations",
            element: <GenerationHistoryPage />
          },
          {
            path: "/admin/generations",
            element: <GenerationAuditPage />
          },
          {
            path: "/admin",
            element: <AdminLayout />,
            children: [
              { index: true, element: <OverviewPage /> },
              { path: "usage", element: <UsagePage /> },
              { path: "tasks", element: <GenerationTasksPage /> },
              { path: "audit", element: <AuditPage /> },
              { path: "members", element: <MembersPage /> },
              { path: "feedback", element: <FeedbackPage /> },
              { path: "feedback/:caseId", element: <FeedbackDetail /> }
            ]
          },
          {
            path: "/projects/:projectId",
            element: <ProductionCanvasPage />
          }
        ]
      },
      {
        path: "*",
        element: <Navigate to="/projects" replace />
      }
    ]
  }
]);
